import {ReactElement} from 'react';
import {KonvaEventObject} from 'konva/lib/Node';
import {Circle, Group, Shape} from 'react-konva';

type AnchorProps = {
  x: number;
  y: number;
  onDelete: () => void;
};

export default function DeleteAnchor({x, y, onDelete}: AnchorProps): ReactElement {
  function onMouseDown(event: KonvaEventObject<MouseEvent>) {
    event.cancelBubble = true;
    onDelete();
  }

  function onTouchStart(event: KonvaEventObject<TouchEvent>) {
    event.cancelBubble = true;
    onDelete();
  }

  return (
    <Group x={x} y={y}>
      <Circle
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
        x={0}
        y={0}
        radius={10}
        fill="red"
        perfectDrawEnabled={false}
      />
      <Shape
        sceneFunc={(context) => {
          context.beginPath();
          context.moveTo(-3, -3);
          context.lineTo(3, 3);
          context.moveTo(-3, 3);
          context.lineTo(3, -3);
          context.closePath();
          context.lineWidth = 2;
          context.strokeStyle = 'white';
          context.stroke();
        }}
        x={0}
        y={0}
        perfectDrawEnabled={false}
      />
    </Group>
  );
}
